import { Moment, utc } from 'moment';
import { HourlyPoolScheduleItem } from 'api/types';
import { formatTimeSlot, getEndTime, getNextHour } from 'utils/time-utils';

interface TimeSlot {
  startTime: string;
  endTime: string;
  capacity: number;
}

/**
 * If user changes start or end time, apply old capacities
 *
 * @param timeSlotStart the start time in 'hh:mm' format
 * @param timeSlotEnd the end time in 'hh:mm' format
 * @param oldCapacityItems existing capacity items
 * @returns capacity the found capacity or 0
 */
// function getExistingCapacity<T extends TimeSlot>(
//   timeSlotStart: string,
//   timeSlotEnd: string,
//   oldCapacityItems: T[],
// ): number {
//   const oldCapacityItem = oldCapacityItems.find((item) =>
//     timeSlotEnd === item.endTime && timeSlotStart === item.startTime
//   );
//   return oldCapacityItem ? oldCapacityItem.capacity : 0;
// }




// function getExistingCapacity<T extends TimeSlot>(
//   timeSlotStart: string,
//   timeSlotEnd: string,
//   oldCapacityItems: T[],
// ): number {
//   // Exact match: preserve existing capacity
//   const exactMatch = oldCapacityItems.find(
//     (item) =>
//       item.startTime === timeSlotStart &&
//       item.endTime === timeSlotEnd,
//   );

//   if (exactMatch) {
//     return exactMatch.capacity;
//   }

//   const start = utc(timeSlotStart, 'HH:mm');
//   const end = utc(timeSlotEnd, 'HH:mm');

//   // Sum all smaller slots contained within this range
//  return oldCapacityItems.reduce((total, item) => {
//   const itemStart = utc(item.startTime, 'HH:mm');

//   const isInside =
//     !itemStart.isBefore(start) &&
//     (itemStart.isBefore(end) || itemStart.isSame(end));

//   return isInside ? total + item.capacity : total;
// }, 0);
// }



function getExistingCapacity<T extends TimeSlot>(
  timeSlotStart: string,
  timeSlotEnd: string,
  oldCapacityItems: T[],
): number {
  const start = utc(timeSlotStart, 'HH:mm');
  const end = utc(timeSlotEnd, 'HH:mm');

  // Exact match only when no smaller slots are present
  const exactMatch = oldCapacityItems.find(
    (item) =>
      item.startTime === timeSlotStart &&
      item.endTime === timeSlotEnd,
  );

  const smallerSlots = oldCapacityItems.filter((item) => {
    const itemStart = utc(item.startTime, 'HH:mm');

    return (
      !itemStart.isBefore(start) &&
      (itemStart.isBefore(end) || itemStart.isSame(end))
    );
  });

  // Prefer summing matching 15-minute slots
  if (smallerSlots.length > 0) {
    return smallerSlots.reduce(
      (total, item) => total + item.capacity,
      0,
    );
  }

  return exactMatch?.capacity ?? 0;
}







/**
 * Calculate each time slot between the pool start and end time
 * Partial hours will always be the first or last hour
 * Times are inclusive of the start time plus 15 minutes
 *
 * @param poolStartTime the start time in 'hh:mm' format
 * @param poolEndTime the end time in 'hh:mm' format
 * @param oldCapacityItems the existing capacity items
 * @returns hourlyItems an array of time slots
 */
export function duplicatecalculateTimeSlots<T extends TimeSlot>(
  poolStartTime: string,
  poolEndTime: string,
  oldCapacityItems: T[],


): HourlyPoolScheduleItem[] {
  if (!poolStartTime || !poolEndTime) {
    return [];
  }

  const timeSlots: HourlyPoolScheduleItem[] = [];
  const scheduleEndTime = utc(poolEndTime, 'hh:mm');
  let time = utc(poolStartTime, 'hh:mm');


  while (time.hour() !== scheduleEndTime.hour()) {
    //  const capacityslot:any=[]
    const endTime = getEndTime(time);
    const timeSlotStart = formatTimeSlot(time);
    const timeSlotEnd = formatTimeSlot(endTime);
    const capacityvalue=getIdea(timeSlotStart,timeSlotEnd,oldCapacityItems,poolEndTime)
  


    // Get old capacity the value isn't lost
    const capacity:any = capacityvalue

    timeSlots.push({
      startTime: timeSlotStart,
      endTime: timeSlotEnd,
      capacity: capacity
    });

    time = getNextHour(time);
  }

  if (scheduleEndTime.minute() === 0) {
    // Time ends on top of hour add extra slot
    const timeSlotStartAndEnd = formatTimeSlot(time);
    timeSlots.push({
      startTime: timeSlotStartAndEnd,
      endTime: timeSlotStartAndEnd,
      capacity: getExistingCapacity(timeSlotStartAndEnd, timeSlotStartAndEnd, oldCapacityItems)
    });
  
    
  } else {
    // Partial end time
    const timeSlotStart = formatTimeSlot(time);
    const timeSlotEnd = formatTimeSlot(scheduleEndTime);
    let capacity=getIdea(timeSlotStart,timeSlotEnd,oldCapacityItems,poolEndTime)
    timeSlots.push({
      startTime: timeSlotStart,
      endTime: timeSlotEnd,
      capacity: capacity
    });
    
  }

  return timeSlots;
}

export function calculateTimeSlots<T extends TimeSlot>(
  poolStartTime: string,
  poolEndTime: string,
  oldCapacityItems: T[],
): HourlyPoolScheduleItem[] {
  if (!poolStartTime || !poolEndTime) {
    return [];
  }

  const timeSlots: HourlyPoolScheduleItem[] = [];
  const scheduleEndTime = utc(poolEndTime, 'hh:mm');
  let time = utc(poolStartTime, 'hh:mm');

  while (time.hour() !== scheduleEndTime.hour()) {
    const endTime = getEndTime(time);
    const timeSlotStart = formatTimeSlot(time);
    const timeSlotEnd = formatTimeSlot(endTime);

    // Get old capacity the value isn't lost
    const capacity = getExistingCapacity(timeSlotStart, timeSlotEnd, oldCapacityItems);

    timeSlots.push({
      startTime: timeSlotStart,
      endTime: timeSlotEnd,
      capacity: capacity
    });

    time = getNextHour(time);
  }

  if (scheduleEndTime.minute() === 0) {
    // Time ends on top of hour add extra slot
    const timeSlotStartAndEnd = formatTimeSlot(time);
    timeSlots.push({
      startTime: timeSlotStartAndEnd,
      endTime: timeSlotStartAndEnd,
       capacity: getExistingCapacity(timeSlotStartAndEnd, timeSlotStartAndEnd, oldCapacityItems)
    });
  } else {
    // Partial end time
    const timeSlotStart = formatTimeSlot(time);
    const timeSlotEnd = formatTimeSlot(scheduleEndTime);
    timeSlots.push({
      startTime: timeSlotStart,
      endTime: timeSlotEnd,
      capacity: getExistingCapacity(timeSlotStart, timeSlotEnd, oldCapacityItems)
    });
  }

  return timeSlots;
}


export function calculateTimeSlotsMinuteWise<T extends TimeSlot>(
  poolStartTime: string,
  poolEndTime: string,
  oldCapacityItems: T[],
): HourlyPoolScheduleItem[] {
  if (!poolStartTime || !poolEndTime) {
    return [];
  }

  const timeSlots: HourlyPoolScheduleItem[] = [];
  const scheduleEndTime = utc(poolEndTime, 'hh:mm');
  let time = utc(poolStartTime, 'hh:mm');

  while (time <= scheduleEndTime) {
    const timeSlotStart = formatTimeSlot(time);
    const timeSlotEnd = formatTimeSlot(time);

    // Get old capacity the value isn't lost
    const capacity = getExistingCapacity(timeSlotStart, timeSlotEnd, oldCapacityItems);

    timeSlots.push({
      startTime: timeSlotStart,
      endTime: timeSlotEnd,
      capacity: capacity
    });

    time = getNextHourMinuteWise(time);
  }

  return timeSlots;
} 



// function distributeCapacity(
//   totalCapacity: number,
//   slotCount: number,
// ): number[] {
//   if (slotCount <= 0) return [];

//   const base = Math.floor(totalCapacity / slotCount);
//   let remainder = totalCapacity % slotCount;

//   const capacities = Array(slotCount).fill(base);

//   // Priority: 4th -> 2nd -> 3rd -> 1st
//   const priority = [3, 1, 2, 0];

//   for (const index of priority) {
//     if (remainder === 0) break;

//     if (index < slotCount) {
//       capacities[index] += 1;
//       remainder -= 1;
//     }
//   }

//   return capacities;
// }

// export function calculateTimeSlotsMinute<T extends TimeSlot>(
//   poolStartTime: string,
//   poolEndTime: string,
//   oldCapacityItems: T[],
// ): HourlyPoolScheduleItem[] {
//   if (!poolStartTime || !poolEndTime) {
//     return [];
//   }

//   const timeSlots: HourlyPoolScheduleItem[] = [];
//   const scheduleEndTime = utc(poolEndTime, 'HH:mm');
//   let time = utc(poolStartTime, 'HH:mm');

//   // Generate 15-minute slots
//   while (time < scheduleEndTime) {
//     const nextTime = getNextHourMinuteWise(time);

//     const slotEnd = nextTime.isAfter(scheduleEndTime)
//       ? scheduleEndTime
//       : nextTime;

//     const start = formatTimeSlot(time);
//     const end = formatTimeSlot(slotEnd);

//     timeSlots.push({
//       startTime: start,
//       endTime: end,
//       capacity: 0,
//     });

//     time = slotEnd;
//   }

//   // Group slots by their original hourly period
//   let i = 0;

//   while (i < timeSlots.length) {
//     const hourStart = timeSlots[i].startTime;
//     const hourStartTime = utc(hourStart, 'HH:mm');
//     const hourEnd = formatTimeSlot(
//       hourStartTime.clone().add(1, 'hour'),
//     );

//     // Get all slots belonging to this hour
//     const hourSlots: HourlyPoolScheduleItem[] = [];

//     while (
//       i < timeSlots.length &&
//       utc(timeSlots[i].startTime, 'HH:mm').isBefore(
//         utc(hourEnd, 'HH:mm'),
//       )
//     ) {
//       hourSlots.push(timeSlots[i]);
//       i++;
//     }

//     // Find the original hourly capacity record
//    const hourlyCapacityItem = oldCapacityItems.find(
//   (item) =>
//     item.startTime === hourStart &&
//     item.endTime === hourEnd,
// );

//     if (hourlyCapacityItem) {
//       const capacities = distributeCapacity(
//         hourlyCapacityItem.capacity,
//         hourSlots.length,
//       );

//       hourSlots.forEach((slot, index) => {
//         slot.capacity = capacities[index];
//       });
//     } else {
//       // Fallback: preserve exact matching 15-minute capacities
//       hourSlots.forEach((slot) => {
//         const existingItem = oldCapacityItems.find(
//           (item) =>
//             item.startTime === slot.startTime &&
//             item.endTime === slot.endTime,
//         );

//         slot.capacity = existingItem?.capacity ?? 0;
//       });
//     }
//   }

//   return timeSlots;
// }




export function distributeCapacity(
  totalCapacity: number,
  slotCount: number,
): number[] {
  if (slotCount <= 0) return [];

  const base = Math.floor(totalCapacity / slotCount);
  let remainder = totalCapacity % slotCount;

  const capacities = Array(slotCount).fill(base);

  // Priority: 4th -> 2nd -> 3rd -> 1st
  const priority = [3, 1, 2, 0];

  for (const index of priority) {
    if (remainder === 0) break;

    if (index < slotCount) {
      capacities[index] += 1;
      remainder--;
    }
  }

  return capacities;
}

export function calculateTimeSlotsMinute<T extends TimeSlot>(
  poolStartTime: string,
  poolEndTime: string,
  oldCapacityItems: T[],
): HourlyPoolScheduleItem[] {
  if (!poolStartTime || !poolEndTime) {
    return [];
  }

  const timeSlots: HourlyPoolScheduleItem[] = [];
  const scheduleStart = utc(poolStartTime, 'HH:mm');
  const scheduleEnd = utc(poolEndTime, 'HH:mm');

  for (const item of oldCapacityItems) {
    const rangeStart = utc(item.startTime, 'HH:mm');
    const rangeEnd = utc(item.endTime, 'HH:mm');

    // Ignore ranges outside the selected schedule
    const start = rangeStart.isAfter(scheduleStart)
      ? rangeStart.clone()
      : scheduleStart.clone();

    const end = rangeEnd.isBefore(scheduleEnd)
      ? rangeEnd.clone()
      : scheduleEnd.clone();

    if (!start.isBefore(end) && !start.isSame(end)) {
      continue;
    }

    if (start.isSame(end)) {
      continue;
    }

    const slots: HourlyPoolScheduleItem[] = [];
    let time = start.clone();

    // Include the range's end time as a slot start,
    // but only when it is inside the selected schedule.
 while (time.isBefore(end) || time.isSame(end)) {
  const nextTime = time.clone().add(15, 'minutes');

  slots.push({
    startTime: formatTimeSlot(time),
    endTime: formatTimeSlot(nextTime),
    capacity: 0,
  });

  time = nextTime;
}

    const capacities = distributeCapacity(
      item.capacity,
      slots.length,
    );

    slots.forEach((slot, index) => {
      slot.capacity = capacities[index];
    });

    timeSlots.push(...slots);
  }

  return timeSlots;
}





export function getNextHourMinuteWise(time: Moment): Moment {
  return time.clone().add(15, 'minutes');
}

export function getIdea(start: any, end: any, data: any, endpoint: any) {
  // Use reduce to accumulate capacity
  let totalCapacity = data.reduce((acc: any, ele: any) => {
    // Check if the current item's start time is before the end time
    if (ele.startTime <= end && ele.startTime >= start) {
      // console.log(ele.startTime , end ,+"or"+ ele.startTime , start)
      return acc + ele.capacity; // Add capacity to the accumulator
    }
    return acc; // Return accumulated value otherwise
  }, 0);

  return totalCapacity;  // You can return this value or do other things with it
}
